export default "__VITE_ASSET__DeZfV6ca__"